export default __webpack_public_path__ + "static/media/p22.ac899690.jpeg";